import type { Route } from './route';

export class RouterHistory {
  private routeStack: Route[] = [];

  constructor(private navigateTo: (route: Route) => Promise<void>) {}

  navigate(route: Route) {
    const current = this.currentRoute();
    const isDifferentPath = current.path !== route.path;

    if (isDifferentPath) {
      this.routeStack.push(current);
    }

    void this.navigateTo(route);
    return;
  }

  currentRoute(): Route {
    const url = new URL(window.location.href);
    const path = url.pathname;

    const query: Record<string, string> = {};

    url.searchParams.forEach((value, key) => {
      query[key] = value;
    });

    return {
      path,
      query,
    };
  }

  back(fallback?: () => void) {
    const previous = this.routeStack.pop();

    if (previous) {
      void this.navigateTo(previous);
      return;
    }
    if (fallback) {
      fallback();
      return;
    }
    this.navigate({ path: '/' });
  }
}
